<template>
  <div ref="swiperCarousel" class="swiper-carousel" :style="{ height: swiperCarouselHeight + 24 + 5 + 'px' }" >
    <div v-if="swiperSlides.length === 0" :style="{ height: swiperCarouselHeight + 'px' }" class="swiper-carousel__loading-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="12" viewBox="0 0 44 12">
        <circle class="dot dot-1" cx="6"  cy="6" r="6"/>
        <circle class="dot dot-2" cx="22" cy="6" r="6"/>
        <circle class="dot dot-3" cx="38" cy="6" r="6"/>
      </svg>
    </div>
    <swiper v-if="swiperSlides.length !== 0" :options="swiperOption"
            :ark-ga-track="'impression'"
            :ark-ga-track-category="'Carousel'"
            :ark-ga-track-dimensions="getImpressionDimensionsAttribute()"
            :ark-ga-track-condition="'arkGaPageHelpers.get({ func: \'defaultTrackCondition\' })'">
      <swiper-slide v-if="swiperSlides" :key="slide.externalId" v-for="slide in swiperSlides">
        <div
          @click="handleGameClick(slide)"
          class="slide">
          <a :href="getGameUrl(slide)"
             class="ark-carousel-slide__link"
             :ark-ga-track="'click'"
             :ark-ga-track-category="'Carousel'"
             :ark-ga-track-condition="'arkGaPageHelpers.get({ func: \'defaultTrackCondition\' })'"
             :ark-ga-track-dimensions="getClickDimensionsAttribute(slide.externalId)">
            <img class="slide__img" :src="getImg(slide)" alt="">
            <div class="slide__footer">
              <a :href="getGameUrl(slide)"
                 class="slide__button"><span class="slide__button-text">{{locale.play}}</span><i class="triangle-right"></i></a>
            </div>
          </a>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div v-bind:class="['swiper-button-prev', {'swiper-button-always-show': alwaysShowNav}]" slot="button-prev"></div>
      <div v-bind:class="['swiper-button-next', {'swiper-button-always-show': alwaysShowNav}]" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
const Vue = window.Vue

export default {
  inherit: true,
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      notNextTick: true,
      locale: this.$parent.config.locale,
      config: this.$parent.config,
      alwaysShowNav: this.$parent.config.alwaysShowNav,
      swiperOption: {
        autoplay: 3000,
        setWrapperSize: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        mousewheelControl: false,
        observeParents: true,
        loop: true,
        slidesPerView: 1
      },
      swiperSlidesIds: [],
      swiperSlides: [],
      swiperCarouselWidth: 0
    }
  },
  created: function () {
    this.updateCarousel()
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
    this.handleWindowResize()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    swiperCarouselHeight () {
      return 295 / 640 * this.swiperCarouselWidth
    }
  },
  methods: {
    updateCarousel: function () {
      Vue.http.get(this.config.backUrl, {
        headers: {
          'X-CDN-Target-Host': this.config.arenaName
        }
      }).then(response => {
        if (this.config.platform) {
          this.swiperSlides = response.body.contents.filter(item => {
            return !item.settings.platform || item.settings.platform.indexOf(this.config.platform) !== -1
          })
        } else {
          this.swiperSlides = response.body.contents
        }
        this.swiperSlidesIds = this.getAllIds()
        setTimeout(function () {
          if (typeof window.ark !== 'undefined') {
            window.ark.triggerEvent('arkCarouselWidgetReady')
          }
        }, 500)
      }, response => {
        console.error(response)
      })
    },
    getImg (slide) {
      if (slide.assets) {
        let img = slide.assets.filter(item => (item.key === '640x295'))[0]
        if (img) {
          return img.url
        }
      }
      return ''
    },
    getAllIds () {
      let res = []
      for (let i = 0; i < this.swiperSlides.length; i++) {
        res.push(this.swiperSlides[i].externalId)
      }
      return res
    },
    getImpressionDimensionsAttribute () {
      return `[{slot: '6', value: '${this.swiperSlidesIds.join('|')}'}]`
    },
    getClickDimensionsAttribute (gameId) {
      return `[{slot: '5', value: '${gameId}|${this.swiperSlidesIds.indexOf(gameId)}'}]`
    },
    handleWindowResize () {
      this.swiperCarouselWidth = this.$refs.swiperCarousel.clientWidth
    },
    handleGameClick (game) {
      setTimeout(function () {
        window.location.href = '/games/' + game.externalId
      }, 300)
    },
    getGameUrl (game) {
      if (game.pageName) {
        return '/games/' + game.pageName
      }
      return '/games/' + game.externalId
    }
  }
}
</script>

<style lang="scss">
  @import './carousel-vendor';
  @import './carousel';
  .ark-carousel-slide__link {
    display: block;
  }
  .swiper-slide {
    height: auto;
  }
  svg { opacity: .2; }
   .dot { transform-origin: 50% 50%; -webkit-transform-origin: 50% 50%;
     -webkit-animation: bouncedelay 1s infinite ease-in-out both;
     animation: bouncedelay 1s infinite ease-in-out both; }
  .dot-1 { -webkit-animation-delay: -.54s; animation-delay: -.54s}
  .dot-2 { -webkit-animation-delay: -.48s; animation-delay: -.48s}
  .dot-3 { -webkit-animation-delay: -.32s; animation-delay: -.32s}
  @-webkit-keyframes bouncedelay {
    0%,80%,100%{ -webkit-transform: scale(0.8); }	40%{ -webkit-transform: scale(1); } }
  @keyframes bouncedelay {
    0%,80%,100%{ transform: scale(0.8); }	40%{ transform: scale(1); } }
</style>



// WEBPACK FOOTER //
// carousel.vue?4d3476b9